
















import { Component, Vue } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';

@Component
export default class ItemList extends Vue {
  @Mutation
  public updateMaxItems: any;
  @Getter
  public getMaxItems!: number;
  @Getter
  public isShowingAllItems!: boolean;
}
